"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_utils_1 = require("mobx-utils");
const lodash_1 = require("lodash");
const util_1 = require("./util");
class Entity {
    constructor(id, props) {
        // override me to make specific computed properties enumerable
        this.enumerableComputed = [];
        this.getDeep = mobx_utils_1.computedFn(function getDeep(key) {
            return lodash_1.get(this.propsWithoutID, key);
        });
        /** @deprecated use PropsWithoutID */
        this.WithoutID = null;
        /** @deprecated use Props */
        this.WithID = null;
        this.id = util_1.toNum(id);
        this.internalProps = props;
    }
    assign(props) {
        if (!props)
            return this;
        const { id } = props, assign = __rest(props, ["id"]);
        if (id && util_1.isDevelop) {
            throw new Error('Assigning an ID! This was probably unintentional!');
        }
        Object.assign(this.internalProps, assign);
        return this;
    }
    edit(cb) {
        return this.assign(cb(this.internalProps));
    }
    get(key) {
        return this.propsWithoutID[key];
    }
    set(key, val) {
        this.internalProps[key] = val;
    }
    get propsWithoutID() {
        return this.addComputedProps(Object.assign({}, this.internalProps));
    }
    get props() {
        return this.addComputedProps(Object.assign(Object.assign({}, this.internalProps), { id: this.id }));
    }
    propsAnd(...keys) {
        return keys.reduce((acc, key) => Object.assign(acc, { [key]: this.get(key) }), Object.assign({}, this.props));
    }
    addComputedProps(obj) {
        if (!this.computedPropsCache)
            this.computedPropsCache = this.initComputedProps();
        for (const [key, getter] of this.computedPropsCache) {
            Object.defineProperty(obj, key, {
                get: getter.get,
                configurable: false,
                enumerable: this.enumerableComputed.includes(key),
            });
        }
        return obj;
    }
    initComputedProps() {
        if (!this.computed)
            return [];
        // IMPORTANT: the reference to this.internalProps is very relevant here
        const computedProps = this.computed(this.internalProps, this.id);
        const result = [];
        // prototype hacking to get a list of getters that aren't enumerable
        for (const [key, prop] of Object.entries(Object.getOwnPropertyDescriptors(computedProps))) {
            if (key !== 'constructor') {
                if (prop.get) {
                    // with some fancy magic, we can do mobx's @computed on any getters
                    const handle = mobx_1.computed(prop.get.bind(computedProps));
                    result.push([key, { get: () => handle.get() }]);
                    // we mutate the incoming computedProps, so that references
                    // between computed properties are @computed, not direct references to each other
                    Object.defineProperty(computedProps, key, {
                        get: () => handle.get(),
                        configurable: false,
                    });
                }
                else {
                    result.push([key, { get: () => prop.value }]);
                }
            }
        }
        return result;
    }
    /** @deprecated use props */
    get $() {
        return this.props;
    }
    /** @deprecated use props */
    get withID() {
        return this.props;
    }
    /** @deprecated use propsWithoutID */
    get withoutID() {
        return this.propsWithoutID;
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], Entity.prototype, "internalProps", void 0);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Entity.prototype, "assign", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], Entity.prototype, "edit", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof K !== "undefined" && K) === "function" ? _a : Object, Object]),
    __metadata("design:returntype", void 0)
], Entity.prototype, "set", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Entity.prototype, "propsWithoutID", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Entity.prototype, "props", null);
exports.Entity = Entity;
exports.default = Entity;
//# sourceMappingURL=entity.js.map